module.exports = __webpack_public_path__ + "static/media/shortening.04b9b6c9.jpg";